/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import classNames from 'classnames';

interface NumberFormatProps {
  value: any;
  emptyValue?: string | number;
  prefix?: string;
  suffix?: string;
  abbreviate?: boolean;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
  decimalPlaces?: number;
  className?: string;
  hasTooltip?: boolean;
}

const bands = [
  { label: 'quadrillion', value: 1000000000000000, units: 'Q' },
  { label: 'trillion', value: 1000000000000, units: 'T' },
  { label: 'billion', value: 1000000000, units: 'B' },
  { label: 'million', value: 1000000, units: 'M' },
  { label: 'thousand', value: 1000, units: 'k' },
  { label: 'nada', value: 1, units: '' }
];

const NumberFormat = (props: NumberFormatProps) => {

  // const getDecimalPlaces = (value: any) => {
  //   let decimalPlaces = 1;
  //   if (props.decimalPlaces === undefined) {
  //     return 20; // this is the maximum decimals for toLocalString()
  //   } else if (parseFloat(props.value) >= 1000 && value * 10 % 10 === 0) { // 1.0M => 1M
  //     decimalPlaces = 0;
  //   }
  //   return decimalPlaces;
  // }

  if ((!props.value && props.value !== 0) || isNaN(props.value)) {
    return (<span className='dont_translate'>{(props.emptyValue || props.emptyValue === 0) ? props.emptyValue : '-'}</span>);
  }

  const prefix = props.prefix || '';
  let value = parseFloat(props.value);
  let units = '';

  if (props.abbreviate) {
    for (let i = 0, length = bands.length; i < length; i++) {
      if (value >= bands[i].value) {
        units = bands[i].units;
        value = value / bands[i].value;
        break;
      }
    }
  }

  const { maximumFractionDigits, minimumFractionDigits, decimalPlaces } = props;
  const formatterSettings = {
    maximumFractionDigits: maximumFractionDigits ?? 4,
    minimumFractionDigits,
    decimalPlaces
  };

  if (decimalPlaces !== undefined) {
    formatterSettings.maximumFractionDigits = decimalPlaces;
    formatterSettings.minimumFractionDigits = decimalPlaces;
  }

  // const valueString = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // this doesn't work for tiny numbers like 0.00531234123
  const valueString = value.toLocaleString('en-GB', formatterSettings);

  return (
    <SimpleTooltip
      className={classNames('dont_translate', props.className)}
      text={props.hasTooltip ? `${prefix}${value}${units}${props.suffix}` : ''}
    >
      <span className='dont_translate'>
        {prefix}{valueString}{units}{props.suffix}
      </span>
    </SimpleTooltip>
  );
}

export default NumberFormat;
